import { ApiError } from '@frontend/api-utils';
import { IoTHealthClient } from '@frontend/iot/api';

import { AndroidWebViewApp, AndroidWebViewNetworkStatus } from '../../android-webview/android-webview-app';

const androidWebView = AndroidWebViewApp.getInstance();

export async function resolveNetworkStatus(): Promise<AndroidWebViewNetworkStatus> {
    const nativeStatus = androidWebView.getNetworkStatus();

    if (nativeStatus) {
        return nativeStatus;
    }

    const backendConnected = await checkIoTConnection();

    return {
        deviceConnected: navigator.onLine,
        // Reaching the IoT backend implies public network reachability.
        networkConnected: backendConnected,
        backendConnected
    };
}

async function checkIoTConnection(): Promise<boolean> {
    try {
        return await IoTHealthClient.checkHealth();
    } catch (error) {
        if (error instanceof ApiError && error.code && error.code >= 400 && error.code < 500) {
            return true;
        }

        return false;
    }
}
